import { AppID } from '@ikonintegration/idmclient';
//
import APIRequest from './core/Request';
// API Compoenents
import OperationTrail from './operations/Trail';
import OperationClient from './operations/Client';
//
export default class Client {
  /* config structure
    {
      endpoint: 'https://localhost',
      port: 9998,
      apiKey: '',
      namespace: '',
      authorizationToken: '' -- optional
    }
  */
  constructor(config) {
    this.config = config;
    // api operations
    this.trail = new OperationTrail(this);
    this.client = new OperationClient(this);
  }

  async newBaseRequest(method) {
    const req = new APIRequest(method);
    //Auth
    if (this.config.apiKey) {
      const iToken = new AppID(null, this.config.apiKey, this.config.apiKey);
      req.appendHeader('API-Key', iToken.getHash());
    }
    if (this.config.authorizationToken) {
      let token = this.config.authorizationToken;
      if (typeof this.config.authorizationToken === "function") {
        token = await this.config.authorizationToken();
      }
      req.appendHeader('Authorization', token);
    }
    if (this.config.namespace) {
      req.appendHeader('Namespace', this.config.namespace);
    }
    //
    req.baseURL = this.config.endpoint;
    if (this.config.port) req.baseURL += `:${this.config.port}`;
    //
    return req;
  }
}
